module.exports = __webpack_public_path__ + "img/egg_production.d0419132.svg";